"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredBucketAttributeKeys = exports.Cohort = exports.COHORT_VERSION = exports.ATL_COHORT = void 0;
var _cookie = require("../../utils/cookie");
var _guid = require("../../utils/guid");
var _helpers = require("./helpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */
var ATL_COHORT = exports.ATL_COHORT = 'atlCohort';
var COHORT_VERSION = exports.COHORT_VERSION = '2';
var requiredBucketAttributeKeys = exports.requiredBucketAttributeKeys = ['index', 'bucketedAtUTC', 'version', 'bucketId'];
var cohortBuckets = {
  bucketAll: {
    bucketId: 0
  }
};
/**
 * Provides public access to cohort cookie name and methods for reading and writing that cookie
 * @module Cohort
 */
var Cohort = exports.Cohort = /*#__PURE__*/function () {
  function Cohort() {
    _classCallCheck(this, Cohort);
  }
  return _createClass(Cohort, null, [{
    key: "readAtlCohort",
    value:
    /*
       Hypothetical way to add other buckets (adding their name to the types above):
           if (isMobileDevice()) {
              cohortBuckets.bucket_mobile = {
                  bucketId: 1
              };
          }
           if (isEnglishSpeaking()) {
              cohortBuckets.bucket_english = {};
          }
           function isMobileDevice() {
              // some logic here...
              return true;
          }
           function isEnglishSpeaking() {
              // some logic here...
              return false;
          }
      */

    /**
     * Tries to read the ATL_COHORT cookie and return it
     * @function readAtlCohort
     * @return {object | null} the cohort object or null
     */
    function readAtlCohort() {
      var atlCohort;
      var atlCohortCookie = _cookie.Cookie.readCookie(ATL_COHORT);
      try {
        atlCohort = atlCohortCookie ? JSON.parse(atlCohortCookie) : null;
        return _helpers.Helpers.isObject(atlCohort) ? atlCohort : null;
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error reading ALT_COHORT Cookie');
        return null;
      }
    }

    /**
     * Writes the stringified `atlCohort` object to the `ATL_COHORT` cookie
     * @function writeAtlCohort
     * @ignore
     * @param {object} atlCohort the cohort object
     */
  }, {
    key: "writeAtlCohort",
    value: function writeAtlCohort(atlCohort) {
      if (_helpers.Helpers.isObject(atlCohort)) {
        _cookie.Cookie.writeCookie(ATL_COHORT, JSON.stringify(atlCohort), 3650, true);
      }
    }

    /**
     * Checks to see if a bucket is in the `atlCohort` object and returns `true` if it does and `false` if it does not
     * @function bucketExists
     * @ignore
     * @param  {BucketName} key a bucket key
     * @param  {Partial<AtlCohort>} atlCohort the cohort object
     * @return {boolean} whether or not a bucket is in the cohort object
     */
  }, {
    key: "bucketExists",
    value: function bucketExists(key, atlCohort) {
      if (_helpers.Helpers.isObject(atlCohort)) {
        var bucket = atlCohort[key];
        if (bucket && _helpers.Helpers.isObject(bucket)) {
          return requiredBucketAttributeKeys.every(function (bucketAttribute) {
            return typeof bucket[bucketAttribute] !== 'undefined';
          });
        }
      }
      return false;
    }

    /**
     * Takes a `bucketKey` and returns and object with `index` and `bucketedAtUTC` properties and optional attribute properties
     * @function createBucket
     * @ignore
     * @param  {string} bucketKey
     * @return {object} a bucket object
     */
  }, {
    key: "createBucket",
    value: function createBucket(bucketKey) {
      var bucketAttributes = cohortBuckets[bucketKey];
      var anonymousId = _cookie.Cookie.readCookie('ajs_anonymous_id');
      var bucket = {
        bucketedAtUTC: new Date().toISOString(),
        version: COHORT_VERSION,
        index: anonymousId ? _guid.Guid.guidHashCode(_guid.Guid.addNumberToGUID(anonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
        bucketId: bucketAttributes.bucketId
      };
      return bucket;
    }

    /**
     * Reads `ATL_COHORT` cookie and if there are any missing buckets, it adds them and writes them to the cookie. Returns the `atlCohort` object
     * @function readWriteAtlCohort
     * @param {boolean} writeOverride when present, trigger a cohort rewrite
     * @return {object | null} the cohort object or null
     */
  }, {
    key: "readWriteAtlCohort",
    value: function readWriteAtlCohort(writeOverride) {
      // if overriding the cohort, do not read the existing cohort; set to empty to force a write
      var atlCohort = writeOverride ? {} : Cohort.readAtlCohort() || {};
      var missingBuckets = Object.keys(cohortBuckets)
      // Find missing buckets
      .filter(function (bucket) {
        return !Cohort.bucketExists(bucket, atlCohort);
      });
      if (missingBuckets.length) {
        missingBuckets.forEach(function (missingBucket) {
          return atlCohort[missingBucket] = Cohort.createBucket(missingBucket);
        });
        Cohort.writeAtlCohort(atlCohort);
      }
      return atlCohort;
    }
  }]);
}();